import React, { useState } from 'react';
import cobranzasService from '../services/cobranzasService';

const BloqueoCobranzaModal = ({
    isOpen,
    isBlocked,
    cobranzaStatus,
    onClose,
    onSuccessUpload,
    onLogout
}) => {
    const [file, setFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState('');
    const [notes, setNotes] = useState('');
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState('');
    const [successData, setSuccessData] = useState(null);
    const [showZoomImage, setShowZoomImage] = useState(false);

    if (!isOpen) return null;

    const status = cobranzaStatus?.status;
    const isRejected = status === 'REJECTED';
    const isManuallyBlocked = Boolean(cobranzaStatus?.is_manually_blocked);
    const manualBlockReason = cobranzaStatus?.manual_block_reason;
    const rejectionReason = cobranzaStatus?.latest_receipt?.rejection_reason || cobranzaStatus?.rejection_reason || '';
    const monthlyAmount = cobranzaStatus?.monthly_amount || '20.00';
    const config = cobranzaStatus?.global_config;

    // Resolver URL de la imagen del flyer / banner de pago
    const rawBannerUrl = config?.payment_image_url || cobranzaStatus?.payment_image_url;
    const paymentBannerUrl = cobranzasService.getMediaUrl(rawBannerUrl);

    const handleFileChange = (e) => {
        const selected = e.target.files[0];
        if (selected) {
            setFile(selected);
            setError('');
            if (selected.type.startsWith('image/')) {
                setPreviewUrl(URL.createObjectURL(selected));
            } else {
                setPreviewUrl('');
            }
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFile = e.dataTransfer.files[0];
        if (droppedFile) {
            setFile(droppedFile);
            setError('');
            if (droppedFile.type.startsWith('image/')) {
                setPreviewUrl(URL.createObjectURL(droppedFile));
            } else {
                setPreviewUrl('');
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) {
            setError('Por favor selecciona la imagen del comprobante de transferencia.');
            return;
        }

        try {
            setUploading(true);
            setError('');
            const res = await cobranzasService.uploadReceipt(file, notes);
            setSuccessData(res);
            if (onSuccessUpload) {
                onSuccessUpload(res);
            }
        } catch (err) {
            console.error('Error subiendo comprobante:', err);
            setError(err.response?.data?.detail || 'Ocurrió un error al subir el comprobante. Intenta nuevamente.');
        } finally {
            setUploading(false);
        }
    };

    const handleContinue = async () => {
        setSuccessData(null);
        setFile(null);
        setPreviewUrl('');
        setError('');
        if (onSuccessUpload) {
            await onSuccessUpload(successData);
        }
        if (onClose) {
            onClose();
        }
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: isBlocked ? 'rgba(15, 23, 42, 0.88)' : 'rgba(0, 0, 0, 0.55)',
            backdropFilter: isBlocked ? 'blur(8px)' : 'none',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2000,
            padding: '1rem'
        }}>
            <div style={{
                background: '#ffffff',
                borderRadius: '16px',
                maxWidth: '680px',
                width: '100%',
                maxHeight: '94vh',
                overflowY: 'auto',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                border: isBlocked ? '2px solid #ef4444' : '1px solid #e2e8f0',
                position: 'relative'
            }}>
                {/* Header */}
                <div style={{
                    padding: '1.25rem 1.5rem',
                    borderBottom: '1px solid #f1f5f9',
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    background: isBlocked ? (isRejected || isManuallyBlocked ? '#fef2f2' : '#fff1f2') : '#f8fafc',
                    borderTopLeftRadius: '16px',
                    borderTopRightRadius: '16px'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                        <div style={{
                            width: '46px',
                            height: '46px',
                            borderRadius: '12px',
                            background: isBlocked ? '#fee2e2' : '#e0f2fe',
                            color: isBlocked ? '#dc2626' : '#0284c7',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '1.5rem',
                            flexShrink: 0
                        }}>
                            <i className={isBlocked ? 'bi bi-shield-lock-fill' : 'bi bi-credit-card-2-front-fill'}></i>
                        </div>
                        <div>
                            <h3 style={{ margin: 0, fontSize: '1.2rem', fontWeight: 'bold', color: '#1e293b' }}>
                                {isBlocked
                                    ? (isManuallyBlocked
                                        ? 'Servicio Suspendido Administrativamente'
                                        : isRejected
                                            ? 'Comprobante Rechazado - Sistema Bloqueado'
                                            : 'Servicio Suspendido por Falta de Pago')
                                    : (config?.title || 'Datos de Pago y Subida de Comprobante')}
                            </h3>
                            <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.85rem', color: '#64748b' }}>
                                Mensualidad a Reportar: <strong>${monthlyAmount} USD</strong>
                            </p>
                        </div>
                    </div>

                    {!isBlocked && (
                        <button
                            onClick={onClose}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                fontSize: '1.6rem',
                                color: '#94a3b8',
                                cursor: 'pointer',
                                padding: '0.2rem',
                                lineHeight: '1'
                            }}
                        >
                            &times;
                        </button>
                    )}
                </div>

                {/* Body */}
                <div style={{ padding: '1.5rem' }}>
                    {/* IMAGEN / FLYER / BANNER DE PAGO (GRANDE Y PREDOMINANTE) */}
                    {paymentBannerUrl ? (
                        <div style={{
                            textAlign: 'center',
                            marginBottom: '1.5rem',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                        }}>
                            <div
                                onClick={() => setShowZoomImage(true)}
                                style={{
                                    display: 'inline-block',
                                    borderRadius: '14px',
                                    overflow: 'hidden',
                                    boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.15)',
                                    border: '1px solid #e2e8f0',
                                    cursor: 'pointer',
                                    maxWidth: '100%',
                                    background: '#ffffff',
                                    transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                                }}
                                title="Haz clic para ver en pantalla completa"
                            >
                                <img
                                    src={paymentBannerUrl}
                                    alt="Cuentas Bancarias y QR de Pago"
                                    style={{
                                        maxHeight: '460px',
                                        width: 'auto',
                                        maxWidth: '100%',
                                        objectFit: 'contain',
                                        display: 'block'
                                    }}
                                />
                            </div>
                            <span style={{ fontSize: '0.75rem', color: '#64748b', marginTop: '0.5rem', display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }}>
                                <i className="bi bi-zoom-in" style={{ color: '#0284c7' }}></i> Clic en la imagen para ampliar
                            </span>
                        </div>
                    ) : (
                        <div style={{
                            padding: '1.5rem',
                            textAlign: 'center',
                            background: '#f8fafc',
                            borderRadius: '12px',
                            border: '1px solid #e2e8f0',
                            color: '#64748b',
                            marginBottom: '1.5rem'
                        }}>
                            <i className="bi bi-credit-card-2-front" style={{ fontSize: '2rem', color: '#94a3b8', display: 'block', marginBottom: '0.5rem' }}></i>
                            Por favor realiza tu transferencia mensual y sube el comprobante a continuación.
                        </div>
                    )}

                    {successData ? (
                        <div style={{ textAlign: 'center', padding: '1.5rem 0' }}>
                            <div style={{
                                width: '64px',
                                height: '64px',
                                borderRadius: '50%',
                                background: '#dcfce7',
                                color: '#16a34a',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '2.2rem',
                                margin: '0 auto 1rem auto'
                            }}>
                                <i className="bi bi-check-lg"></i>
                            </div>
                            <h4 style={{ color: '#15803d', fontWeight: 'bold', fontSize: '1.2rem', marginBottom: '0.5rem' }}>
                                ¡Comprobante Recibido con Éxito!
                            </h4>
                            <p style={{ color: '#475569', fontSize: '0.9rem', lineHeight: '1.5', maxWidth: '500px', margin: '0 auto' }}>
                                {successData.extracted_data?.amount ? (
                                    <>Monto detectado automáticamente: <strong>${successData.extracted_data.amount} USD</strong>. </>
                                ) : null}
                                El sistema ha sido <strong>desbloqueado temporalmente</strong> para todos los usuarios mientras el Gestor de Cobranzas audita el pago.
                            </p>
                            <button
                                type="button"
                                onClick={handleContinue}
                                style={{
                                    marginTop: '1.5rem',
                                    background: '#16a34a',
                                    color: '#ffffff',
                                    border: 'none',
                                    padding: '0.8rem 2.2rem',
                                    borderRadius: '8px',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    fontSize: '1rem',
                                    boxShadow: '0 4px 6px -1px rgba(22, 163, 74, 0.3)'
                                }}
                            >
                                Continuar al Sistema
                            </button>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit}>
                            {/* Dropzone para subir comprobante */}
                            <div
                                onDragOver={(e) => e.preventDefault()}
                                onDrop={handleDrop}
                                style={{
                                    border: '2px dashed #cbd5e1',
                                    borderRadius: '12px',
                                    padding: '1.5rem',
                                    textAlign: 'center',
                                    background: '#f8fafc',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    position: 'relative'
                                }}
                                onClick={() => document.getElementById('comprobante-input-file').click()}
                            >
                                <input
                                    id="comprobante-input-file"
                                    type="file"
                                    accept="image/*,application/pdf"
                                    onChange={handleFileChange}
                                    style={{ display: 'none' }}
                                />

                                {previewUrl ? (
                                    <div>
                                        <img
                                            src={previewUrl}
                                            alt="Vista previa comprobante"
                                            style={{
                                                maxHeight: '180px',
                                                maxWidth: '100%',
                                                borderRadius: '8px',
                                                objectFit: 'contain',
                                                boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)'
                                            }}
                                        />
                                        <p style={{ margin: '0.5rem 0 0 0', fontSize: '0.825rem', color: '#0284c7', fontWeight: 'bold' }}>
                                            <i className="bi bi-arrow-repeat"></i> Clic para cambiar imagen de comprobante
                                        </p>
                                    </div>
                                ) : (
                                    <div>
                                        <i className="bi bi-cloud-arrow-up-fill" style={{ fontSize: '2.5rem', color: 'var(--primary-color, #4a1f0c)' }}></i>
                                        <p style={{ margin: '0.5rem 0 0.25rem 0', fontWeight: 'bold', color: '#1e293b', fontSize: '0.95rem' }}>
                                            {file ? file.name : 'Arrastra tu captura de comprobante aquí o haz clic'}
                                        </p>
                                        <span style={{ fontSize: '0.775rem', color: '#64748b' }}>
                                            Sube tu comprobante de Banco Pichincha, Guayaquil, Produbanco, Deuna, etc.
                                        </span>
                                    </div>
                                )}
                            </div>

                            {/* Notas opcionales */}
                            <div style={{ marginTop: '1rem' }}>
                                <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: '600', color: '#475569', marginBottom: '0.35rem' }}>
                                    Notas adicionales (Opcional):
                                </label>
                                <input
                                    type="text"
                                    placeholder="Ej: Transferencia realizada desde Banco Pichincha por Juan Pérez"
                                    value={notes}
                                    onChange={(e) => setNotes(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '0.65rem 0.85rem',
                                        borderRadius: '8px',
                                        border: '1px solid #cbd5e1',
                                        fontSize: '0.875rem'
                                    }}
                                />
                            </div>

                            {error && (
                                <div style={{
                                    marginTop: '1rem',
                                    padding: '0.75rem',
                                    background: '#fef2f2',
                                    border: '1px solid #fecaca',
                                    borderRadius: '8px',
                                    color: '#dc2626',
                                    fontSize: '0.85rem'
                                }}>
                                    <i className="bi bi-exclamation-circle-fill"></i> {error}
                                </div>
                            )}

                            {/* Botones */}
                            <div style={{
                                display: 'flex',
                                gap: '0.75rem',
                                marginTop: '1.5rem',
                                justifyContent: isBlocked ? 'space-between' : 'flex-end',
                                alignItems: 'center'
                            }}>
                                {isBlocked && (
                                    <button
                                        type="button"
                                        onClick={onLogout}
                                        style={{
                                            background: 'transparent',
                                            color: '#64748b',
                                            border: '1px solid #cbd5e1',
                                            padding: '0.7rem 1.25rem',
                                            borderRadius: '8px',
                                            fontWeight: '500',
                                            cursor: 'pointer',
                                            fontSize: '0.875rem'
                                        }}
                                    >
                                        <i className="bi bi-box-arrow-left"></i> Cerrar Sesión
                                    </button>
                                )}

                                <button
                                    type="submit"
                                    disabled={uploading}
                                    style={{
                                        background: uploading ? '#94a3b8' : 'var(--primary-color, #4a1f0c)',
                                        color: '#ffffff',
                                        border: 'none',
                                        padding: '0.75rem 1.75rem',
                                        borderRadius: '8px',
                                        fontWeight: 'bold',
                                        cursor: uploading ? 'not-allowed' : 'pointer',
                                        fontSize: '0.95rem',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.5rem',
                                        boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)'
                                    }}
                                >
                                    {uploading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Analizando Comprobante con OCR...
                                        </>
                                    ) : (
                                        <>
                                            <i className="bi bi-send-fill"></i>
                                            {isBlocked ? 'Enviar y Reactivar Servicio' : 'Enviar Comprobante'}
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>

            {/* Modal Zoom Imagen / Flyer de Pago */}
            {showZoomImage && paymentBannerUrl && (
                <div
                    onClick={() => setShowZoomImage(false)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: 'rgba(0,0,0,0.88)',
                        zIndex: 3500,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '1.5rem'
                    }}
                >
                    <div style={{ position: 'relative', maxWidth: '92vw', maxHeight: '92vh', textAlign: 'center' }}>
                        <img
                            src={paymentBannerUrl}
                            alt="Cuentas Bancarias Ampliadas"
                            style={{ maxWidth: '100%', maxHeight: '82vh', borderRadius: '12px', objectFit: 'contain', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)' }}
                        />
                        <p style={{ color: '#ffffff', marginTop: '0.75rem', fontSize: '0.95rem', fontWeight: '500' }}>
                            Haz clic en cualquier parte para cerrar
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BloqueoCobranzaModal;
